/*
 * Tessuti - solid-colour swatches, never a photo thumbnail.
 *
 * Two places fall back to a product photo whenever
 * snippets/tessuti-color-hex.liquid finds no tessuti_color_swatch match for a
 * colour name - true for Odoo's numbered fabric codes like "SC:10", which are
 * only unique WITHIN one fabric line, so they can't be given a single global
 * hex without risking a different product's colour (see the swatch-backfill
 * note in memory):
 *
 *   - the product page picker:  <label class="t-pd__color t-pd__color--img">
 *   - the product card dots:    <button class="t-pc__dot t-pc__dot--img">
 *
 * Kunal wants no photo in either - only a colour dot. This never touches
 * sections/tessuti-product.liquid or snippets/tessuti-product-card.liquid.
 * It replaces each fallback <img> with a solid colour, coloured with the
 * AVERAGE pixel colour sampled from that same swatch photo - a real,
 * product-specific colour instead of a generic placeholder, and instead of a
 * photo.
 *
 * This script is loaded sitewide via snippets/scripts.liquid, so it runs on
 * the product page, collection grids, search results and the cart drawer
 * alike - anywhere a .t-pc product card can appear.
 */
(function () {
  'use strict';

  function injectStyle() {
    if (document.getElementById('t-pd-coloravg-style')) return;
    var st = document.createElement('style');
    st.id = 't-pd-coloravg-style';
    // The section's own CSS sets `display:block` on these <img> tags, which
    // otherwise beats the [hidden] default.
    st.textContent =
      '.t-pd__color--img img[hidden],.t-pc__dot--img img[hidden]{display:none !important;}';
    document.head.appendChild(st);
  }

  function averageColor(img) {
    try {
      var size = 16;
      var c = document.createElement('canvas');
      c.width = size; c.height = size;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, size, size);
      var data = ctx.getImageData(0, 0, size, size).data;
      var r = 0, g = 0, b = 0, n = 0;
      for (var i = 0; i < data.length; i += 4) {
        if (data[i + 3] < 32) continue; // skip near-transparent pixels
        r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
      }
      if (!n) return null;
      r = Math.round(r / n); g = Math.round(g / n); b = Math.round(b / n);
      function h(x) { return ('0' + x.toString(16)).slice(-2); }
      return '#' + h(r) + h(g) + h(b);
    } catch (e) {
      return null; // tainted canvas or unreadable image - fall through
    }
  }

  // Re-fetch through a CORS-mode request: the swatch <img> already in the
  // page was not loaded with crossOrigin set, so canvas pixel reads on it
  // throw even though Shopify's CDN sends the right headers. The duplicate
  // request is served from cache.
  function loadForSampling(src) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = src;
    });
  }

  // Product-page picker: the visible circle is a sibling <span>/<img> sized
  // by `.t-pd__color span` - insert a matching span and hide the photo.
  function paintWithSpan(el, img, hex) {
    var span = document.createElement('span');
    span.style.background = hex;
    el.insertBefore(span, img);
    img.hidden = true;
  }

  // Product card dot: the hex branch paints straight onto the <button> via
  // an inline style, no child span - match that and hide the photo.
  function paintOnSelf(el, img, hex) {
    el.style.background = hex;
    img.hidden = true;
  }

  function process(el, paint) {
    if (el.dataset.avgDone === '1') return;
    el.dataset.avgDone = '1';
    var img = el.querySelector('img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    injectStyle();
    loadForSampling(src)
      .then(function (im) {
        paint(el, img, averageColor(im) || '#C9A961');
      })
      .catch(function () {
        paint(el, img, '#C9A961');
      });
  }

  function init() {
    document.querySelectorAll('.t-pd__color--img').forEach(function (el) {
      process(el, paintWithSpan);
    });
    document.querySelectorAll('.t-pc__dot--img').forEach(function (el) {
      process(el, paintOnSelf);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor / dynamic section re-renders (e.g. a card swapped into the
  // cart drawer, a collection grid re-rendering on filter change).
  document.addEventListener('shopify:section:load', init);
  // Product cards can also appear after the initial render (infinite scroll,
  // AJAX collection filtering, cart drawer updates via Section Rendering) -
  // catch those without depending on a specific theme event.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { init(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
